import React from "react";
import { cn } from "../lib/utils";
import { Loader2 } from "lucide-react";

export function KenteStripe({ className }) {
  return <div className={cn("kente-stripe h-1 w-full", className)} data-testid="kente-stripe" />;
}

export function Button({ variant = "primary", className, children, ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium tracking-wide transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary: "bg-blood text-bone hover:bg-[#7A1515] border border-blood",
    gold: "bg-gold text-ink hover:bg-[#c5a230] border border-gold font-semibold",
    outline: "bg-transparent text-gold border border-gold hover:bg-gold hover:text-ink",
    ghost: "bg-transparent text-bone hover:text-gold",
  };
  return (
    <button className={cn(base, variants[variant], className)} {...props}>
      {children}
    </button>
  );
}

export function Spinner({ className }) {
  return (
    <div className={cn("flex items-center justify-center py-24", className)} data-testid="loading-spinner">
      <Loader2 className="h-8 w-8 animate-spin text-gold" />
    </div>
  );
}

export function Pill({ children, tone = "gold", className }) {
  const tones = {
    gold: "border-gold/40 text-gold",
    blood: "border-blood/50 text-[#e07a72]",
    forest: "border-forest/60 text-[#7bbd7e]",
    muted: "border-edge text-muted",
  };
  return (
    <span
      className={cn(
        "inline-block border px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em]",
        tones[tone],
        className
      )}
    >
      {children}
    </span>
  );
}

export function SectionLabel({ children }) {
  return (
    <div className="mb-4 flex items-center gap-3">
      <span className="h-px w-8 bg-gold" />
      <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-gold">{children}</span>
    </div>
  );
}
